/** Раскладка English QWERTY (ANSI и ISO). */

import type { Finger } from '@type2x/shared-contracts';

import { buildKeys, chars } from './build.js';
import type { KeyboardLayout } from './types.js';

const LP: Finger = 'left-pinky';
const LR: Finger = 'left-ring';
const LM: Finger = 'left-middle';
const LI: Finger = 'left-index';
const RI: Finger = 'right-index';
const RM: Finger = 'right-middle';
const RR: Finger = 'right-ring';
const RP: Finger = 'right-pinky';
const TH: Finger = 'right-thumb';

export const EN_QWERTY: KeyboardLayout = {
  id: 'en-qwerty',
  language: 'en',
  platform: 'windows',
  homeRowAnchors: ['a', 's', 'd', 'f', 'j', 'k', 'l', ';'],
  keys: buildKeys([
    {
      row: 'number',
      base: chars('`1234567890-='),
      shifted: chars('~!@#$%^&*()_+'),
      fingers: [LP, LP, LR, LM, LI, LI, RI, RI, RM, RR, RP, RP, RP],
    },
    {
      row: 'top',
      base: chars('qwertyuiop[]\\'),
      shifted: chars('QWERTYUIOP{}|'),
      fingers: [LP, LR, LM, LI, LI, RI, RI, RM, RR, RP, RP, RP, RP],
    },
    {
      row: 'home',
      base: chars("asdfghjkl;'"),
      shifted: chars('ASDFGHJKL:"'),
      fingers: [LP, LR, LM, LI, LI, RI, RI, RM, RR, RP, RP],
    },
    {
      row: 'bottom',
      base: chars('zxcvbnm,./'),
      shifted: chars('ZXCVBNM<>?'),
      fingers: [LP, LR, LM, LI, LI, RI, RI, RM, RR, RP],
    },
    {
      row: 'space',
      base: [' '],
      shifted: [''],
      fingers: [TH],
    },
  ]),
};
